import { render, staticRenderFns } from "./qualificacao-economica.vue?vue&type=template&id=608abae4&scoped=true"
import script from "./qualificacao-economica.vue?vue&type=script&lang=js"
export * from "./qualificacao-economica.vue?vue&type=script&lang=js"
import style0 from "./qualificacao-economica.vue?vue&type=style&index=0&id=608abae4&prod&scoped=true&lang=css"
import style1 from "./qualificacao-economica.vue?vue&type=style&index=1&id=608abae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608abae4",
  null
  
)

export default component.exports